import gql from 'graphql-tag';

export const addUrednideska = gql`
  mutation addUrednideska($input: [UredniDeskaInput!]!) {
    response: addUrednideska(inputUrednideska: $input) {
      id
    }
  }
`;
